/* eslint-disable max-len */
/* eslint-disable max-params */

import axios from 'axios';
import qs from 'qs';

const Promise = require('bluebird');

function axiosAuthWrapper({ method, url, config, data }) {
    return new Promise((resolve, reject) => {
        const headers = {
            Accept: config.acceptHeader,
            'Accept-Language': config.userLang
        };
        if (config.bearerToken) {
            headers.Authorization = `bearer ${config.bearerToken}`;
        }
        axios({
            method,
            url: `${config.apiUrl}${url}`,
            data,
            headers
        })
            .then(resolve, reject)
            .catch(error => {
                reject(error);
            });
    });
}

export const fetchSearchResultsFromAPI = (state, userLang, location, tag, params, trackingCookieId, adminModeId, isAdmin, fromCache) => {
    return new Promise((resolve, reject) => {
        fromCache = fromCache || false;
        const config = state.config;
        const queryObj = qs.parse(params);
        if (!(fromCache && queryObj.s_tag)) {
            delete queryObj.s_tag;
        }
        let curatedUrl = `search?${qs.stringify(queryObj)}&tag=${tag.quick_slug}&location=${location}&tracking_cookie_id=${trackingCookieId}`;
        if (adminModeId) {
            curatedUrl = `${curatedUrl}&admin_mode_id=${adminModeId}`;
        }
        axiosAuthWrapper({
            method: 'GET',
            url: curatedUrl,
            config
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch(reject);
    });
};

export const fetchSearchVerticalsFromAPI = config => {
    return new Promise((resolve, reject) => {
        axiosAuthWrapper({
            method: 'GET',
            url: `verticals`,
            config
        })
            .then(response => {
                resolve(response.data);
            },
            err => reject(err))
            .catch(error => {
                reject(error);
            });
    });
};

export const fetchTagsFromAPI = config => {
    return new Promise((resolve, reject) => {
        axiosAuthWrapper({
            method: 'GET',
            url: `tagging/search_labels`,
            config
        })
            .then(response => {
                resolve(response.data);
            },
            err => reject(err))
            .catch(error => {
                reject(error);
            });
    });
};

export const fetchTagFromAPI = (config, tagSlug) => {
    return new Promise((resolve, reject) => {
        axiosAuthWrapper({
            method: 'GET',
            url: `tagging/metas_by_slug/${tagSlug}`,
            config
        })
            .then(response => {
                resolve(response.data);
            },
            err => reject(err))
            .catch(error => {
                reject(error);
            });
    });
};

export const fetchAdminTagsFromAPI = config => {
    return new Promise((resolve, reject) => {
        axiosAuthWrapper({
            method: 'GET',
            url: 'tags_deprecated',
            config
        })
            .then(response => {
                resolve(response.data);
            }, err => reject(err))
            .catch(reject);
    });
};

export const putAssetTagViaAPI = (config, assetId, tagId) => {
    return new Promise((resolve, reject) => {
        axiosAuthWrapper({
            method: 'PUT',
            url: `assets/${assetId}/tags`,
            config,
            data: {
                tag_id: tagId
            }
        })
            .then(response => {
                resolve(response.data);
            },
            err => reject(err))
            .catch(reject);
    });
};

export const putAssetImageFlagViaAPI = (config, imageId, flagged) => {
    return new Promise((resolve, reject) => {
        axiosAuthWrapper({
            method: 'PUT',
            url: `images/${imageId}/flag`,
            config,
            data: {
                flagged
            }
        })
            .then(response => {
                resolve(response.data);
            },
            err => reject(err))
            .catch(reject);
    });
};

export const deleteAssetTagViaAPI = (config, assetId, tagId) => {
    return new Promise((resolve, reject) => {
        axiosAuthWrapper({
            method: 'DELETE',
            url: `assets/${assetId}/tags/${tagId}`,
            config
        })
            .then(() => {
                resolve(tagId);
            },
            err => reject(err))
            .catch(reject);
    });
};

export const setUrl = (apiUrl, userLang, location, tag, paramsString, searchToken, addHistory = true, replaceState = false) => {
    const params = qs.parse(paramsString);
    if (searchToken) {
        params.s_tag = searchToken;
    }
    delete params.action;
    delete params.location_string;
    delete params.eventType;
    if (typeof window !== 'undefined' && window.history) {
        const url = `${
            window.location.origin
        }/${
            window.location.pathname.split('/')[1]
        }/${
            window.location.pathname.split('/')[2]
        }/${
            tag.quick_slug
        }/${
            location
        }?${
            qs.stringify(params)
        }`;
        if (addHistory) {
            if (replaceState) {
                window.history.pushState({
                    apiUrl,
                    userLang,
                    location,
                    tag,
                    params
                }, null, url);
            } else {
                window.history.pushState({
                    apiUrl,
                    userLang,
                    location,
                    tag,
                    params
                }, null, url);
            }
        }
    }
};

export const putFavouriteViaAPI = (userId, assetId) => {
    return new Promise((resolve, reject) => {
        axiosAuthWrapper({
            method: 'PUT',
            url: `users/${userId}/favourites`,
            data: {
                asset_id: assetId
            }
        })
            .then(() => {
                resolve(assetId);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export const deleteFavouriteViaAPI = (userId, assetId) => {
    return new Promise((resolve, reject) => {
        axiosAuthWrapper({
            method: 'DELETE',
            url: `users/${userId}/favourites/${assetId}`
        })
            .then(() => {
                resolve(assetId);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export const updateTagRankingViaAPI = (config, assetId, tagId, tagRanking) => {
    return new Promise((resolve, reject) => {
        axiosAuthWrapper({
            method: 'PUT',
            url: `assets/${assetId}/tags`,
            config,
            data: {
                tag_id: tagId,
                ranking: tagRanking
            }
        })
            .then(() => {
                resolve(tagRanking);
            },
            err => reject(err))
            .catch(reject);
    });
};

export const putAgreedToListViaAPI = (config, venueId, agreedToList) => {
    return new Promise((resolve, reject) => {
        axiosAuthWrapper({
            method: 'PATCH',
            url: `venues/${venueId}/agreed`,
            config,
            data: {
                agreed_to_list: agreedToList
            }
        })
            .then(() => {
                resolve(agreedToList);
            },
            err => reject(err))
            .catch(reject);
    });
};

export const putRoomVerticalViaAPI = (config, assetId, verticalId) => {
    return new Promise((resolve, reject) => {
        axiosAuthWrapper({
            method: 'PUT',
            url: `rooms/${assetId}/vertical_change`,
            config,
            data: {
                vertical_id: verticalId
            }
        })
            .then(response => {
                resolve(response.data);
            },
            err => reject(err))
            .catch(reject);
    });
};



// WEBPACK FOOTER //
// ./src/pages/Search/methods/index.js